import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=0b625105&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=ts"
export * from "./highlight.vue?vue&type=script&lang=ts"
import style0 from "./highlight.vue?vue&type=style&index=0&id=0b625105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b625105",
  null
  
)

export default component.exports